









































































































import { Component,  Prop,  Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
@Component({
  name: 'infoDetailDrawer',
  components: {}
})
export default class extends Vue {
  @Prop() public drawer!: boolean;
  @Prop() public drawerDisplay!: string;
  @Prop() public detailData: any;
  @Prop() public lastRank: number = 1;

  public displayOption = 'appFee';

  public title = "";

  public get langEN() {
    if (AppModule.language === 'en-us') {
      return true;
    } else {
      return false;
    }
  }

 @Watch('drawerDisplay', { immediate: true }) public onDrawerDisplayChange() {
    if (this.drawerDisplay === 'lang') {
      this.title = this.$t('insInfoSearch.infoTypeLanguageReq').toString();
    } else {
      this.title = this.$t('insInfoSearch.infoTypeApplicationFee').toString();
    }
    this.displayOption = this.drawerDisplay;
  }

  public cancelDrawerForm() {
    this.$emit('cancel-drawer-form');
  }
  public beforeClose() {
    this.$emit('close')
  }
  public goLang() {
    this.displayOption = 'lang';
    this.title = this.$t('insInfoSearch.infoTypeLanguageReq').toString();
  }
  public goAppFee() {
    this.displayOption = 'appFee';
    this.title = this.$t('insInfoSearch.infoTypeApplicationFee').toString();
  }
  public async changeExpand(row: any) {
    row.active = !row.active;
  }
  public previousDrawerForm() {
    this.$emit('previous-drawer-form');
  }
  public nextDrawerForm() {
    this.$emit('next-drawer-form');
  }
}
